function index() {
  return <div className="terms-conditions" data-sentry-component="index" data-sentry-source-file="index.jsx">
            <div className="container">
                <div className="terms-conditions-wrapper">
                    <div className="terms-conditions-txt">
                        <h3>The first fully 'HALAL' fast food chain</h3>
                        <p>
                            assionately conceptualize in Dubai, United Arab Emirates, the first Chicking® outlet was
                            established in the year 2000, and since then, the brand has grown to become extremely
                            popular in 27+ countries with more than 230+ outlets. In India First outlet opened in MG
                            Road and now spread more than 80 outlets including Kerala, Tamil Nadu, Karnataka, Mumbai &
                            Delhi. This impressive growth was achieved by understanding what families prefer. We are
                            also a big favourite amongst individuals who are looking for a tasty alternative to
                            formulaic fast food.
                        </p>
                        <p>
                            ChicKing, established as part of the highly reputable and renowned Dubai based Banquet Foods
                            International, RAK-FZE, UAE. ChicKing® began its journey with a simple yet determined dream
                            &ndash; To create a brand that brings happiness, satisfaction and smiles to our valued
                            customers world-over. Over the years, it has successfully realized this dream by making
                            ChicKing® a favorite destination for real and tasty fried chicken. ChicKing &ndash; A brand
                            that has been built with over a decade of commitment and unmatched quality continues to make
                            tremendous strides within its sphere of business. Whether its global expansion, new menu or
                            innovative services and outlets, the change is charismatic and the customers have been
                            lapping it with great passion.
                        </p>
                        <p></p>
                        <h3>Innovation served hot</h3>
                        <p>
                            Product innovation is one of the primary focus points at Chicking®. Our range of exciting
                            flavours, inspired by taste cultures from around the world, have been refined through
                            constant research and development, into the signature, deliciously secret recipes enjoyed
                            today. Owing to the fact that individuals and families often develop their own personal
                            tastes, the Chicking® menu features a wide variety such as our signature Original
                            (non-spicy), Fried (Spicy) & Grilled Chicken (perfectly ove grilled), Boneless Chicken
                            Strips, Mexita, Crunchy Supreme Burgers, Royal Wraps, Taco Wrap and Chicken Bites, and Fries
                            with our Tandoori Flavour, Pinoy BBQ, Hot Wings, Double Crunchy, Soho Rice and Chicking
                            Peri-peri chicken served Half/Full with 4 special Sauces
                        </p>
                        <p>
                            Even our beverages showcase innovation through Frizzr, a unique range of refreshing
                            mocktails in a variety of highly popular flavours. At Chicking® we understand that
                            innovation is not just about staying relevant to local market conditions and growth
                            strategies. We have an excellent support structure in place for all franchisees and
                            partners, ensuring constant collaboration and satisfaction on products, services and value.
                            The Chicking® concept is designed to be easily adaptable to a variety of retail spaces and
                            can be flawlessly used in most settings such as food courts, dine-in restaurants, kiosks,
                            standalone or drive-thru facilities.
                        </p>
                        <p></p>
                        <h3>Passion & Commitment</h3>
                        <p>
                            Chicking® started with a vision of our founder & chairman, Mr. A. K. Mansoor, who
                            identified the need for a fully Halal compliant QSR that serves great tasting food in an
                            inviting environment. Back then, the choice available was very limited, and so after
                            thorough market research, the Chicking® team passionately created a range of outstanding
                            recipes, which includes our signature tastes and pioneering food concepts. From the time it
                            was launched, Chicking® was a runaway success.
                        </p>
                        <p>
                            Chicking® is a registered international trademark registered under Banquet foods
                            International FZE. Since then, Mr. A. K. Mansoor has boldly innovated by creating an
                            exciting and varied menu that is inspired by taste cultures from around the world and
                            winning millions of customers along the way. Now Chicking has grown extremely popular in 30+
                            countries with more than 230+ outlets and opening much-more new locations near you.
                        </p>
                    </div>
                </div>
            </div>
        </div>;
}
export default index;